// extracted by mini-css-extract-plugin
export default {"root":"styles_root__11bMs","body2":"styles_body2__3Rpqu","seperator":"styles_seperator__1MWl6"};